// src/pages/tenant/TenantCreatePage.tsx
// Legacy route kept resolvable for old links/bookmarks. Tenant creation now
// happens through TenantCreateDialog (form-kit), opened from TenantListPage's
// "+ New" — see docs/ux/14-forms.md. This route just sends people there.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const TenantCreatePage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/tenants', { replace: true });
  }, [navigate]);
  return null;
};

export default TenantCreatePage;
